"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var material_1 = require("@angular/material");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var publish_data_model_1 = require("./publish-data.model");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var publish_service_1 = require("../service/publish.service");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var lodash_1 = require("lodash");
var from_1 = require("rxjs/observable/from");
var ReportPublishDialogComponent = /** @class */ (function () {
    function ReportPublishDialogComponent(dialogRef, publishService, data, messageService, currentLanguageProvider) {
        this.dialogRef = dialogRef;
        this.publishService = publishService;
        this.data = data;
        this.messageService = messageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.NAME_ERROR = 'reporting.controls.publish.name.error';
        this.PERIODICITY_ERROR = 'reporting.controls.publish.periodicity.error';
        this.PERIODICITY_LIMITATION_ERROR = 'reporting.controls.publish.periodicity.limitation.error';
        this.DAY_ERROR = 'reporting.controls.publish.day.error';
        this.DAY_LIMITATION_ERROR = 'reporting.controls.publish.available.day.error';
        this.Periodicity = publish_data_model_1.Periodicity;
        this.errorKeys = new Map();
        this.isReady = false;
        this.showURl = false;
        this.repeatMessageKeys = new Map()
            .set('reporting.controls.publish.repeats.minutely', publish_data_model_1.Periodicity.MINUTELY)
            .set('reporting.controls.publish.repeats.hourly', publish_data_model_1.Periodicity.HOURLY)
            .set('reporting.controls.publish.repeats.daily', publish_data_model_1.Periodicity.DAILY)
            .set('reporting.controls.publish.repeats.monthly', publish_data_model_1.Periodicity.MONTHLY);
        this.dayPosInMonth = new Map()
            .set('reporting.controls.publish.first', publish_data_model_1.DayPosInMonth.FIRST)
            .set('reporting.controls.publish.last', publish_data_model_1.DayPosInMonth.LAST);
        this.daysOfMessageKeys = new Map()
            .set('reporting.controls.publish.day', publish_data_model_1.DayOfMonth.MONTHDAY);
        this.destroy$ = new Subject_1.Subject();
        this.reportWidgetId = data.widgetId;
        this.getExportDto = data.getExportDto;
        this.pageId = +data.pageId;
    }
    ReportPublishDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentLanguageProvider.getCurrentLanguage()
            .pipe(operators_1.switchMap(function (language) {
            _this.currentLanguageId = language.getId();
            return _this.initPublishData();
        }), operators_1.takeUntil(this.destroy$))
            .subscribe(function (publishData) {
            if (publishData) {
                _this.oldPublishData = publishData;
                _this.publishData = lodash_1.cloneDeep(publishData);
                _this.initComboBoxesValues();
                _this.isReady = true;
                _this.showURl = true;
            }
        }, function (error) {
            if (error.status === 404) {
                _this.oldPublishData = new publish_data_model_1.PublishData(null, _this.pageId, null, null, new publish_data_model_1.Schedule(publish_data_model_1.Periodicity.MONTHLY, null, null, null, publish_data_model_1.DayOfMonth.MONTHDAY, null), null);
                _this.publishData = lodash_1.cloneDeep(_this.oldPublishData);
                _this.initComboBoxesValues();
                _this.isReady = true;
            }
        });
    };
    ReportPublishDialogComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    ReportPublishDialogComponent.prototype.cancel = function () {
        this.dialogRef.close();
    };
    ReportPublishDialogComponent.prototype.isPublishDataChanged = function () {
        var isValid = false;
        if (this.publishData && this.publishData.title) {
            if ([publish_data_model_1.Periodicity.MINUTELY, publish_data_model_1.Periodicity.HOURLY, publish_data_model_1.Periodicity.DAILY].includes(this.publishData.schedule.periodicity)) {
                isValid = !!this.publishData.schedule.periodicityInterval;
            }
            if (this.publishData.schedule.periodicity === publish_data_model_1.Periodicity.MONTHLY) {
                isValid = Boolean(this.publishData.schedule.periodicityInterval && (this.publishData.schedule.day && this.publishData.schedule.dayWithPosition && this.publishData.schedule.selectedOptionInMonthId === 1
                    ||
                        this.publishData.schedule.dayPositionInMonth && this.publishData.schedule.selectedOptionInMonthId === 2));
            }
        }
        return isValid && JSON.stringify(this.oldPublishData) !== JSON.stringify(this.publishData);
    };
    ReportPublishDialogComponent.prototype.initPublishData = function () {
        return this.publishService.get(this.reportWidgetId, this.currentLanguageId);
    };
    ReportPublishDialogComponent.prototype.initComboBoxesValues = function () {
        this.initRepeats();
        this.initDayPositionInMonth();
        this.initDaysOfMonth();
    };
    ReportPublishDialogComponent.prototype.initRepeats = function () {
        this.repeats$ = this.getMessageObjects(this.repeatMessageKeys);
    };
    ReportPublishDialogComponent.prototype.initDayPositionInMonth = function () {
        this.dayPositionsInMonth$ = this.getMessageObjects(this.dayPosInMonth);
    };
    ReportPublishDialogComponent.prototype.initDaysOfMonth = function () {
        this.daysOfMonth$ = this.getMessageObjects(this.daysOfMessageKeys);
    };
    ReportPublishDialogComponent.prototype.getMessageObjects = function (messagesMap) {
        return from_1.from(this.messageService.getMessages(this.currentLanguageId, Array.from(messagesMap.keys())))
            .map(function (messageKeys) { return Array.from(messageKeys, function (_a) {
            var key = _a[0], value = _a[1];
            return ({ name: value, id: messagesMap.get(key) });
        }); });
    };
    ReportPublishDialogComponent.prototype.onJobValueChange = function (key, value) {
        var _this = this;
        var errorMessagesKey = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            errorMessagesKey[_i - 2] = arguments[_i];
        }
        if (this.publishData.schedule[key] !== value) {
            this.publishData.schedule[key] = value;
        }
        errorMessagesKey.forEach(function (messageKey) { return _this.errorKeys.set(key, ''); });
    };
    ReportPublishDialogComponent.prototype.onValueChange = function (key, value, requiredMessageKey) {
        if (this[key] !== value) {
            this[key] = value;
        }
        this.errorKeys.set(requiredMessageKey, '');
    };
    ReportPublishDialogComponent.prototype.onNameChange = function (pageTitle) {
        this.onJobValueChange('title', pageTitle, 'pageTitleRequired');
    };
    ReportPublishDialogComponent.prototype.onPeriodicityTimeUnitChange = function (periodicityTimeUnit) {
        this.resetFrequencyOnPeriodicityTimeUnitChange(periodicityTimeUnit);
        this.onJobValueChange('periodicity', periodicityTimeUnit);
    };
    ReportPublishDialogComponent.prototype.resetFrequencyOnPeriodicityTimeUnitChange = function (periodicityTimeUnit) {
        if (periodicityTimeUnit === publish_data_model_1.Periodicity.DAILY) {
            this.errorKeys.set('dayLimitation', '');
            this.errorKeys.set('dayRequired', '');
            this.publishData.schedule.day = this.oldPublishData.schedule.day;
            this.publishData.schedule.dayPositionInMonth = this.oldPublishData.schedule.dayPositionInMonth;
            this.publishData.schedule.dayWithPosition = null;
        }
        if (periodicityTimeUnit === publish_data_model_1.Periodicity.MONTHLY && this.publishData.schedule.selectedOptionInMonthId === 1) {
            this.publishData.schedule.dayWithPosition = publish_data_model_1.DayOfMonth.MONTHDAY;
        }
        else {
            this.publishData.schedule.dayWithPosition = null;
            this.publishData.schedule.day = null;
            this.publishData.schedule.dayPositionInMonth = null;
        }
    };
    ReportPublishDialogComponent.prototype.onPeriodicityChange = function (periodicity) {
        this.onJobValueChange('periodicityInterval', periodicity, 'periodicityRequired');
        if (periodicity !== null && (periodicity < 1 || periodicity > 32767)) {
            this.errorKeys.set('periodicityLimitation', this.PERIODICITY_LIMITATION_ERROR);
        }
        else {
            this.errorKeys.set('periodicityLimitation', '');
        }
    };
    ReportPublishDialogComponent.prototype.onDayChange = function (day) {
        this.onJobValueChange('day', day, 'dayRequired');
        if (day !== null && (day < 1 || day > 31)) {
            this.errorKeys.set('dayLimitation', this.DAY_LIMITATION_ERROR);
        }
        else {
            this.errorKeys.set('dayLimitation', '');
        }
    };
    ReportPublishDialogComponent.prototype.onDayPositionInMonthChange = function (newDayPositionInMonth) {
        this.onJobValueChange('dayPositionInMonth', newDayPositionInMonth);
    };
    ReportPublishDialogComponent.prototype.onMonthOptionsChange = function (isFirstRadioButton) {
        if (isFirstRadioButton) {
            this.publishData.schedule.selectedOptionInMonthId = 1;
            this.publishData.schedule.dayPositionInMonth = null;
            this.publishData.schedule.dayWithPosition = publish_data_model_1.DayOfMonth.MONTHDAY;
        }
        else {
            if (this.publishData.schedule.selectedOptionInMonthId !== 2) {
                this.publishData.schedule.selectedOptionInMonthId = 2;
                this.publishData.schedule.dayWithPosition = null;
                this.publishData.schedule.day = null;
                this.errorKeys.set('dayRequired', '');
                this.errorKeys.set('dayLimitation', '');
            }
        }
    };
    ReportPublishDialogComponent.prototype.save = function () {
        var _this = this;
        if (this.isValidPublishData()) {
            this.showURl = false;
            this.beforeSave();
            this.publishData.exportMeta = this.getExportDto(idm_report_export_service_client_js_1.ExportType.PURE_HTML, idm_dynamic_controls_metadata_1.ExportOrientation.PORTRAIT);
            this.publishData.exportMeta.params = this.convertMapToObject(this.publishData.exportMeta.params);
            this.publishData.exportMeta.headers = {};
            if (!!this.publishData.url) {
                this.publishService.update(this.publishData, this.currentLanguageId)
                    .pipe(operators_1.takeUntil(this.destroy$))
                    .subscribe(function (data) {
                    _this.handleEntityUpsertedData(data);
                });
            }
            else {
                this.publishData.widgetId = this.reportWidgetId;
                this.publishService.create(this.publishData, this.currentLanguageId)
                    .pipe(operators_1.takeUntil(this.destroy$))
                    .subscribe(function (data) {
                    _this.handleEntityUpsertedData(data);
                });
            }
        }
    };
    ReportPublishDialogComponent.prototype.handleEntityUpsertedData = function (data) {
        if (data.success) {
            this.publishData.url = data.url;
            this.publishData.navigationUrl += data.url;
            this.publishData.id = data.id;
            this.oldPublishData = lodash_1.cloneDeep(this.publishData);
            this.showURl = true;
        }
        else {
            this.validations = data.validations;
        }
    };
    ReportPublishDialogComponent.prototype.beforeSave = function () {
        if (!this.publishData.schedule.startTime) {
            (this.publishData.schedule.startTime = new Date().getTime());
        }
        if (this.publishData.schedule.periodicity === publish_data_model_1.Periodicity.HOURLY) {
            this.publishData.schedule.dayPositionInMonth = null;
            this.publishData.schedule.day = null;
        }
    };
    ReportPublishDialogComponent.prototype.isValidPublishData = function () {
        this.errorKeys = this.validatePublishData(this.publishData);
        return this.errorKeys.size === 0;
    };
    ReportPublishDialogComponent.prototype.validatePublishData = function (publishData) {
        var errorMessagesKeys = new Map();
        if (!publishData.title) {
            errorMessagesKeys.set('pageTitleRequired', this.NAME_ERROR);
        }
        if (publishData.schedule.periodicityInterval == null) {
            errorMessagesKeys.set('periodicityRequired', this.PERIODICITY_ERROR);
        }
        else if (publishData.schedule.periodicityInterval < 1 || publishData.schedule.periodicityInterval > 32767) {
            errorMessagesKeys.set('periodicityLimitation', this.PERIODICITY_LIMITATION_ERROR);
        }
        if (publishData.schedule.periodicity === publish_data_model_1.Periodicity.MONTHLY) {
            if (publishData.schedule.selectedOptionInMonthId === 1) {
                if (publishData.schedule.day == null) {
                    errorMessagesKeys.set('dayRequired', this.DAY_ERROR);
                }
                else if (publishData.schedule.day < 1 || publishData.schedule.day > 31) {
                    errorMessagesKeys.set('dayLimitation', this.DAY_LIMITATION_ERROR);
                }
            }
        }
        return errorMessagesKeys;
    };
    ReportPublishDialogComponent.prototype.convertMapToObject = function (mapToConvert) {
        var obj = {};
        mapToConvert.forEach(function (value, key) {
            obj[key] = value;
        });
        return obj;
    };
    ReportPublishDialogComponent = __decorate([
        core_1.Component({
            
            template: require('./report-publish-dialog.component.html'),
            selector: 'sis-tabular-report-view-big-data-warning-popup',
            styles: [require('./report-publish-dialog.component.css')]
        }),
        __param(2, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [material_1.MatDialogRef,
            publish_service_1.PublishService, Object, idm_message_language_service_client_js_1.MessageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], ReportPublishDialogComponent);
    return ReportPublishDialogComponent;
}());
exports.ReportPublishDialogComponent = ReportPublishDialogComponent;
//# sourceMappingURL=report-publish-dialog.component.js.map